import Authorize from "components/Authorize";
import { useGetTenantsQuery } from "./tenantSlice";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import TenantList from "./TenantList/TenantList";
import PageComponent from "components/Page/PageComponent";

const SaasManagementPage = ({ }) => {
    return (
        <PageComponent>
            <TenantList />
        </PageComponent>
    )
}
export default SaasManagementPage;

